export const BRAND_STORY = {
  mission: '모든 차량에 새 차의 감동을 전달합니다',
  vision: '수원 No.1 프리미엄 스팀 세차 브랜드',
  values: [
    { icon: 'Leaf', title: '친환경', desc: '친환경 약품과 스팀으로 환경을 생각합니다' },
    { icon: 'Wrench', title: '전문성', desc: '숙련된 전문가가 한 대 한 대 정성껏' },
    { icon: 'Sparkles', title: '완벽함', desc: '마감 검수까지 꼼꼼하게 마무리합니다' },
  ],
};
